import { render, staticRenderFns } from "./BsGridColumnSelection.vue?vue&type=template&id=75b01bc2&scoped=true&"
import script from "./BsGridColumnSelection.vue?vue&type=script&lang=js&"
export * from "./BsGridColumnSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b01bc2",
  null
  
)

export default component.exports